import type { AudioStorage } from '../../audio/settings'

/**
 * Your best finish time per track (PHASE3 T3.7), in localStorage `runkr.best.<trackId>` as
 * whole ms. The online podium records it when you finish; the profile card shows it. Local to
 * this browser (Phase 2's history is the saved record).
 */
export const BEST_PREFIX = 'runkr.best.'

/** The track the card shows (the one map today). */
export const CARD_TRACK = { id: 'sky_meadow_01', name: 'Sky Meadow' } as const

const TRACK_RE = /^[a-z0-9_]{1,40}$/

export function readBest(storage: AudioStorage, trackId: string): number | null {
  if (!TRACK_RE.test(trackId)) return null
  let raw: string | null
  try {
    raw = storage?.getItem(BEST_PREFIX + trackId) ?? null
  } catch {
    return null
  }
  const ms = raw === null ? NaN : Number(raw)
  return Number.isInteger(ms) && ms > 0 ? ms : null
}

/** Keep `ms` if it beats the stored best; true when it was written. */
export function recordBest(storage: AudioStorage, trackId: string, ms: number): boolean {
  if (!TRACK_RE.test(trackId) || !Number.isFinite(ms) || ms <= 0) return false
  const t = Math.round(ms)
  const best = readBest(storage, trackId)
  if (best !== null && best <= t) return false
  try {
    storage?.setItem(BEST_PREFIX + trackId, String(t))
    return storage != null
  } catch {
    return false
  }
}
